import React from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import Time from "react-time-format";

const MODEL_DISPLAY_NAMES = {
    Product: "بەرهەم",
    ProductTable: "تێبلی بەرهەم",
    Sale: "فرۆشتن",
    Buy: "کڕین",
    Broken: "شکاو",
    Wakil: "وەکیل",
    Para: "پارە",
    Pardan: "پارەدان",
    Mandwb: "مەندوب",
    Garanawa: "گەڕانەوە",
    Masrwfat: "مەسروفات",
    Apeopple: "کەس",
    Paradarhenan: "پارەدەرهێنان",
    Parawargrtn: "پارەوەرگرتن",
    Paraybardast: "پارەی بەردەست",
    ParaGorinawa: "پارە گۆڕینەوە",
    User: "بەکارهێنەر",
    Rent: "کرێ",
    TesxtOnBord: "نوسین",
    Setting: "ڕێکخستن",
    PriceUpdate: "نوێکردنەوەی نرخ",
};

class ScroollTableAuditLog extends React.Component {
    render() {
        return (
            <ProductConsumer>
                {(value) => {
                    const { AL_data, AL_OpenModal } = value;

                    const rows = AL_data.map((log, i) => {
                        const isDelete = log.action === "DELETE";
                        return (
                            <tr
                                key={log._id || i}
                                className="fk"
                                style={{
                                    cursor: "pointer",
                                    borderRight: isDelete
                                        ? "4px solid #dc3545"
                                        : "4px solid #ffc107",
                                }}
                                onClick={() => AL_OpenModal(log._id)}
                            >
                                <td
                                    style={{
                                        border: "1px solid #555",
                                        textAlign: "center",
                                        color: "#999",
                                    }}
                                >
                                    {i + 1}
                                </td>
                                <td style={{ border: "1px solid #555", textAlign: "right" }}>
                                    <Time
                                        value={log.createdAt}
                                        format="YYYY-MM-DD hh:mm:ss"
                                        style={{ color: "#ddd" }}
                                    />
                                </td>
                                <td style={{ border: "1px solid #555", textAlign: "center" }}>
                                    <span
                                        className={`badge ${isDelete ? "badge-danger" : "badge-warning"
                                            }`}
                                        style={{ fontSize: "0.8rem" }}
                                    >
                                        {log.action}
                                    </span>
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #555",
                                        textAlign: "right",
                                        color: "#ddd",
                                    }}
                                >
                                    {MODEL_DISPLAY_NAMES[log.modelName] || log.modelName}
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #555",
                                        textAlign: "right",
                                        color: "#ffa940",
                                        fontFamily: "monospace",
                                        fontSize: "0.8rem",
                                    }}
                                >
                                    {log.documentId
                                        ? log.documentId.substring(0, 12) + "..."
                                        : "-"}
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #555",
                                        textAlign: "right",
                                        color: "#ddd",
                                    }}
                                >
                                    {log.performedBy ? log.performedBy.name : "نەزانراو"}
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #555",
                                        textAlign: "right",
                                        color: "#999",
                                        fontSize: "0.8rem",
                                    }}
                                >
                                    {log.ipAddress || "-"}
                                </td>
                                <td style={{ border: "1px solid #555", textAlign: "center" }}>
                                    <button
                                        className="btn btn-xs btn-outline-info"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            AL_OpenModal(log._id);
                                        }}
                                        title="تفصیلات"
                                    >
                                        <i className="fas fa-eye"></i>
                                    </button>
                                </td>
                            </tr>
                        );
                    });

                    return (
                        <div className="JM">
                            <table
                                className="table table-sm table-hover table-bordered text-right"
                                style={{ backgroundColor: "#2C3539" }}
                            >
                                <thead>
                                    <tr
                                        className="text-warning"
                                        style={{ backgroundColor: "#343a40" }}
                                    >
                                        <th style={{ border: "1px solid #555", textAlign: "center" }}>
                                            #
                                        </th>
                                        <th style={{ border: "1px solid #555" }}>بەروار و کات</th>
                                        <th style={{ border: "1px solid #555", textAlign: "center" }}>
                                            کردار
                                        </th>
                                        <th style={{ border: "1px solid #555" }}>بەش</th>
                                        <th style={{ border: "1px solid #555" }}>ID بەلگە</th>
                                        <th style={{ border: "1px solid #555" }}>لەلایەن</th>
                                        <th style={{ border: "1px solid #555" }}>ئایپی</th>
                                        <th
                                            style={{ border: "1px solid #555", textAlign: "center" }}
                                        >
                                            بینین
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>{rows}</tbody>
                            </table>
                            {AL_data.length === 0 && (
                                <div
                                    className="text-center py-4"
                                    style={{ color: "#999", backgroundColor: "#2C3539" }}
                                >
                                    <i className="fas fa-inbox fa-2x mb-2"></i>
                                    <p>تۆمارێک نەدۆزرایەوە</p>
                                </div>
                            )}
                        </div>
                    );
                }}
            </ProductConsumer>
        );
    }
}

export default ScroollTableAuditLog;
